import type { ColorValue } from "../color-value";
import type { HexColor } from "../hex-color/hex-color";
import type { RgbaArray } from "../rgba-color/rgba-array";
import { colorToRgbaArray } from "./color-to-rgba-array";
import { rgbaToHsla } from "./rgba-to-hsla";

const colorToHsla = (color: HexColor | string | RgbaArray | ColorValue) => {
    const rgba = colorToRgbaArray(color);
    const hsla = rgbaToHsla({
        red: rgba[0],
        green: rgba[1],
        blue: rgba[2],
        alpha: rgba[3],
    });
    return hsla;
};

export { colorToHsla };
